import {
    homeInitialRowIndex,
    homeRowId,
    homeRowsCount,
} from '@/shared/constants'
import { useEffect, useState } from 'react'
import { VodRowViewProps } from '@/types/vod/vodRowType'
import { useVODService } from '@/app/context/DIContext/DIServices'
import { useAppStore, useVODStore } from '@/shared/store'
import {
    selectSetVodRows,
    selectVodRows,
} from '@/shared/store/storeSelectors/vodSelectors'
import { IVODServiceToya } from '@/shared/types/services/types/vodService/vodServiceInterfaces'
import { getErrorMessage, isStreamIQ, isToya } from '@/shared/lib'

export const useHomeContent = (): { homeRows: VodRowViewProps[] } => {
    const [homeRows, setHomeRows] = useState<VodRowViewProps[]>([])
    const vodService = useVODService()
    const setVodRows = useVODStore(selectSetVodRows)
    const vodRows = useVODStore(selectVodRows)
    const { actualProfile } = useAppStore()
    const id = 'HomeContent'
    const homeContent = vodRows.find((cat) => cat.categoryId === id)

    const getHomeContent = async () => {
        try {
            if (isStreamIQ() && 'fetchRowsHome' in vodService) {
                const response = await vodService.fetchRowsHome()

                if (response?.length) {
                    setHomeRows(response)
                    setVodRows(response, id)
                } else if (!response?.length && homeContent?.rows.length) {
                    setHomeRows(homeContent.rows)
                    return
                } else {
                    console.log('No data fetched or cached for Home Page')
                }
            } else if (isToya()) {
                const service = vodService as IVODServiceToya

                const response = await service.getRows(
                    homeRowId,
                    homeInitialRowIndex,
                    homeRowsCount
                )
                if (response) setHomeRows(response)
            }
        } catch (error) {
            getErrorMessage('fetchRowsHome', error)
        }
    }

    useEffect(() => {
        setHomeRows([])
        getHomeContent()
    }, [actualProfile, vodRows])
    return { homeRows }
}

export default useHomeContent
